import React from 'react';

const Dashboard = ({ stats, loading, error, onRefresh, currentUser }) => {
  if (loading) {
    return (
      <div className="loading">
        Carregando estatísticas...
      </div>
    );
  }

  if (error) {
    return (
      <div className="error">
        <h3>Erro ao carregar estatísticas</h3>
        <p>{error}</p>
        <button className="btn btn-primary" onClick={onRefresh}>
          Tentar novamente
        </button>
      </div>
    );
  }

  if (!stats) {
    return (
      <div className="empty-state">
        <h3>Sem dados disponíveis</h3>
        <p>Nenhuma estatística foi encontrada.</p>
        <button className="btn btn-primary" onClick={onRefresh}>
          Recarregar
        </button>
      </div>
    );
  }

  const volunteerStats = stats.volunteers || {};
  const rondaStats = stats.rondas || {};
  const eventStats = stats.events || {};

  return (
    <div>
      <div className="card-header">
        <h3>Painel de Controle</h3>
        <button className="btn btn-primary btn-sm" onClick={onRefresh}>
          Atualizar
        </button>
      </div>

      <div className="stats-grid">
        <div className="stat-card">
          <div className="stat-number">{volunteerStats.total || 0}</div>
          <div className="stat-label">Total de Voluntários</div>
        </div>

        <div className="stat-card">
          <div className="stat-number" style={{ color: '#28a745' }}>
            {volunteerStats.approved || 0}
          </div>
          <div className="stat-label">Voluntários Aprovados</div>
        </div>

        <div className="stat-card">
          <div className="stat-number" style={{ color: '#ffc107' }}>
            {volunteerStats.pending || 0}
          </div>
          <div className="stat-label">Aguardando Aprovação</div>
        </div>

        <div className="stat-card">
          <div className="stat-number" style={{ color: '#17a2b8' }}>
            {rondaStats.total || 0}
          </div>
          <div className="stat-label">Total de Rondas</div>
        </div>

        <div className="stat-card">
          <div className="stat-number" style={{ color: '#6f42c1' }}>
            {eventStats.total || 0}
          </div>
          <div className="stat-label">Total de Eventos</div>
        </div>

        <div className="stat-card">
          <div className="stat-number" style={{ color: '#007bff' }}>
            {eventStats.today || 0}
          </div>
          <div className="stat-label">Eventos Hoje</div>
        </div>
      </div>

      <div className="card">
        <div className="card-header">
          <h3>Informações do Sistema</h3>
        </div>
        <div className="card-content">
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '1rem' }}>
            <div>
              <strong>Última atualização:</strong><br />
              {new Date().toLocaleString('pt-PT')}
            </div>

            <div>
              <strong>Voluntários por status:</strong><br />
              <ul style={{ margin: '0.5rem 0', paddingLeft: '1rem' }}>
                <li>Aprovados: {volunteerStats.approved || 0}</li>
                <li>Pendentes: {volunteerStats.pending || 0}</li>
                <li>Suspensos: {volunteerStats.suspended || 0}</li>
                <li>Rejeitados: {volunteerStats.rejected || 0}</li>
              </ul>
            </div>

            <div>
              <strong>Rondas e Eventos:</strong><br />
              <ul style={{ margin: '0.5rem 0', paddingLeft: '1rem' }}>
                <li>Rondas Ativas: {rondaStats.active || 0}</li>
                <li>Eventos Hoje: {eventStats.today || 0}</li>
                <li>Pessoas Assistidas: {eventStats.total_people_served || 0}</li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {volunteerStats.pending > 0 && (
        <div className="card" style={{ borderLeft: '4px solid #ffc107' }}>
          <div className="card-content">
            <h4 style={{ margin: '0 0 0.5rem 0', color: '#856404' }}>
              ⚠️ Ação Necessária
            </h4>
            <p style={{ margin: 0 }}>
              Existem <strong>{volunteerStats.pending}</strong> voluntários aguardando aprovação.
              Acesse a aba "Voluntários" para processar as solicitações pendentes.
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default Dashboard;